const supportedImages = new Set(['image/png', 'image/jpeg', 'image/webp', 'image/gif']);
const maximumImageBytes = 10 * 1024 * 1024;

const readImages = function(files) {
  return Promise.all(files.map(file => {
    if (!supportedImages.has(file.type)) {
      return Promise.reject(new Error('Use a PNG, JPEG, WebP, or GIF image.'));
    }

    if (file.size > maximumImageBytes) {
      return Promise.reject(new Error('Choose an image smaller than 10 MB.'));
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve({
        id: crypto.randomUUID(),
        src: reader.result,
        name: file.name || 'Pasted image'
      });
      reader.onerror = () => reject(new Error('This image could not be read. Try copying it again.'));
      reader.readAsDataURL(file);
    });
  }));
};

const readClipboard = async function() {
  if (!navigator.clipboard?.read) {
    throw new Error('click the board or a note and use ctrl+v or ⌘v to paste.');
  }

  try {
    const items = await navigator.clipboard.read();
    const files = [];
    const text = [];

    for (const item of items) {
      const imageType = item.types.find(type => supportedImages.has(type));

      if (imageType) {
        files.push(await item.getType(imageType));
      } else if (item.types.includes('text/plain')) {
        text.push(await (await item.getType('text/plain')).text());
      }
    }

    return {
      text: text.join('\n'),
      images: await readImages(files)
    };
  } catch (error) {
    if (error.name === 'NotAllowedError' || error.name === 'SecurityError') {
      throw new Error('click the board or a note and use ctrl+v or ⌘v to paste from your clipboard.');
    }

    throw error;
  }
};

export { readImages, readClipboard };
